<template>
   <div id="fixed-btns" class="fixed-btns">
      <div>
         <router-link 
            v-if="settingsPermission" 
            to="/shortcuts/settings" 
            id="fixed_settings_btn" 
            tooltip 
            :tt-dir="$isArb() ? 'right' : 'left'" 
            :tt-text="$t('lang_program_settings')" 
            tt-fw-bold 
         >
            <i class="fa-solid fa-gear"></i>
         </router-link>

         <router-link 
            to="/notifications" 
            id="fixed_notification_btn" 
            :style="settingsPermission ? '--top: 40' : '--top: 0'" 
            tooltip 
            :tt-dir="$isArb() ? 'right' : 'left'" 
            :tt-text="$t('lang_notifications')" 
            tt-fw-bold
         >
            <i class="fa-solid fa-bell"></i>
            <span></span>
         </router-link>
      </div>
      
      <div id="product_invoice_btn_holder">
         <router-link 
            to="/add_invoice" 
            id="fixed_add_invoice_btn" 
            tooltip 
            :tt-dir="$isArb() ? 'right' : 'left'" 
            :tt-text="$t('lang_new_invoice')" 
            tt-fw-bold 
         >
            <i class="fa-solid fa-plus"></i>
            <lord-icon src="https://cdn.lordicon.com/cllunfud.json" trigger="hover" colors="outline:#ffffff,primary:#eee966,secondary:#ffffff"></lord-icon>
         </router-link>

         <router-link 
            v-if="productsPermission" 
            to="/shortcuts/add_products" 
            id="fixed_add_product_btn" 
            tooltip 
            :tt-dir="$isArb() ? 'right' : 'left'" 
            :tt-text="$t('lang_add_item')" 
            tt-fw-bold
         >
            <i class="fa-solid fa-plus"></i>
            <lord-icon src="https://cdn.lordicon.com/gzcbkoye.json" trigger="hover" ></lord-icon>
         </router-link>
      </div>
   </div>
</template>

<script>
import { reactive, toRefs} from 'vue'
import { useStore }  from 'vuex';


export default {
   
   setup () {
      const store = useStore();
      const permissions = store.getters['permissions/getPermissions'];

      const state = reactive({
         settingsPermission: permissions != null ? (permissions.programsSettings == 'f' ? false : true) : true,
         productsPermission: permissions != null ? (permissions.products == 'f' ? false : true) : true,
      });
   
      return {
         ...toRefs(state),
      }
   },

   created() {
      if (this.$store.state.permissions.permissions != null) {
         this.$watch(() => this.$store.state.permissions.permissions.programsSettings, (newValue) => newValue == 'f' ? this.settingsPermission = false : this.settingsPermission = true);
         this.$watch(() => this.$store.state.permissions.permissions.products, (newValue) => newValue == 'f' ? this.productsPermission = false : this.productsPermission = true);
      }
   }
}
</script>

<style lang="scss" scoped>
   @use '@sass/helpers' as *;
   @use '@sass/variables' as *;
   @use '@sass/animation' as *;

   .fixed-btns {
      #product_invoice_btn_holder {
         position: static;
         z-index: 123;
         left: .5rem;
         bottom: .5rem;
         display: flex;
         justify-content: center;
         align-items: center;
         
         gap: .25rem;
         width: fit-content;
         height: fit-content;
         
         > * { 
            position: fixed;
            z-index: 123;
            bottom: .25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            padding: .25rem !important;
            background: rgba( 0, 0, 0, 0.85 );
            -webkit-backdrop-filter: blur( rem(4) );
            backdrop-filter: blur( rem(4) );
            border: 1px solid rgba( 255, 255, 255, 0.18 );
         }

         #fixed_add_invoice_btn {
            left: .25rem;
         }

         #fixed_add_product_btn {
            right: .25rem;
         }
      
         lord-icon {
            width: rem(29);
            height: rem(29);
         }
      
         @include br(sm) {
            position: fixed;
            flex-direction: column;
            left: .15rem;
            bottom: .15rem;

            > * {
               padding: .5rem !important;
               position: static;
            }

            lord-icon {
               width: rem(35);
               height: rem(35);
            }
         }
      }

      #fixed_notification_btn,
      #fixed_settings_btn {
         position: fixed;
         top: 0;
         right: auto;
         left: 0;
         z-index: 123;
         display: grid;
         place-items: center;
         width: rem(45);
         padding: .5rem;
         color: #000;
         i { font-size: rem(25) }
      
         @include brTo(sm) { display: none }
      
         background-color: rgba($main-clr, .5);
         backdrop-filter: blur(rem(5));
         -webkit-backdrop-filter: blur(rem(5));
      }
      
      #fixed_notification_btn {
         top: calc(var(--top) * 1px);
         border-radius: 0 0 rem(5) 0;
         
         @include brTo(sm) {
            top: 0;
            display: grid;
         }
      
         i { position: relative }
         
         span {
            position: absolute;
            right: rem(5);
            top: rem(3);
            left: auto;
            display: none;
            width: rem(11);
            height: rem(11);
            border-radius: 50%;
            background-color: #ff0000;
            pointer-events: none;
         }
      
         &.animate {
            i { animation: bounce .3s infinite linear alternate }
            span { display: block }
         }
      }
   }
</style>